import { IEmailSendee } from "./email-sendee";

export interface IEmailSendeeResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailSendee;
    }
}